import { render, staticRenderFns } from "./AlbumsList.vue?vue&type=template&id=2d09f908&"
import script from "./AlbumsList.vue?vue&type=script&lang=js&"
export * from "./AlbumsList.vue?vue&type=script&lang=js&"
import style0 from "./AlbumsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports